export default "__VITE_ASSET__Ch3PcX4A__"